import type { ReactNode } from 'react';

import { ReactComponent as CheckIcon } from '../../../assets/icons/check.svg';

import './SetupSection.scss';

interface ISetupSectionProps {
  title: ReactNode;
  done?: boolean;
  action?: ReactNode;
  children?: ReactNode;
}

const SetupSection = ({ title, done, action, children }: ISetupSectionProps) => (
  <section className="setup-section">
    <header className="setup-section__header">
      <h4 className="setup-section__title">{title}</h4>
      {(action || done) && (
        <div className="setup-section__meta">
          {action}
          {done && (
            <span className="setup-section__done" aria-hidden="true">
              <CheckIcon width={14} height={14} />
            </span>
          )}
        </div>
      )}
    </header>
    {children && <div className="setup-section__body">{children}</div>}
  </section>
);

export default SetupSection;
